import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { isSmallUI } from 'shared/app/lib/choose-ui-type';
import { motion } from 'framer-motion';
import { memo } from 'react';
import { DashboardSettings } from './index';
import { DashboardDeviceSettings } from './components/device';
import { DashboardDevicesSettings } from './components/devices';
import { Z3KDashboardSettingsNavigation } from './navigation';
import { Z3KDashboardSettingsProvider } from './provider';
import { DashboardSettingsRoutes } from './types';
import { removeNulls } from 'utils';
const navigation_variants = {
    initial: {
        opacity: 0,
        x: -500,
    },
    show: {
        opacity: 1,
        x: 0,
    },
    hide: {
        opacity: 0,
        x: -500,
    },
};
const page_variants = {
    initial: {
        opacity: 0,
        x: 500,
    },
    show: {
        opacity: 1,
        x: 0,
    },
    hide: {
        opacity: 0,
        x: 500,
    },
};
const transition = { type: 'spring', damping: 15, mass: 0.25, stiffness: 100 };
const MotionBox = motion(Box);
const sx = {
    overflowX: 'hidden',
    overflowY: 'auto',
};
const Setting = memo(function Setting(props) {
    const { children } = props;
    return (_jsx(MotionBox, { p: 2, height: "100%", width: "100%", sx: sx, variants: page_variants, transition: transition, initial: "initial", animate: "show", exit: "hide", children: children }));
});
const Navigation = memo(function Setting(props) {
    const { children } = props;
    return (_jsx(MotionBox, { height: "100%", width: "100%", sx: sx, variants: navigation_variants, transition: transition, initial: "initial", animate: "show", exit: "hide", children: children }, "dashboard-settings-navigation"));
});
export const dasboard_settings_routes = [
    {
        path: DashboardSettingsRoutes.settings,
        element: (_jsx(Z3KDashboardSettingsProvider, { children: _jsx(DashboardSettings, {}) })),
        children: removeNulls([
            isSmallUI()
                ? {
                    path: DashboardSettingsRoutes.navigation,
                    element: (_jsx(Navigation, { children: _jsx(Z3KDashboardSettingsNavigation, {}) })),
                }
                : null,
            {
                path: DashboardSettingsRoutes.devices,
                element: (_jsx(Setting, { children: _jsx(DashboardDevicesSettings, {}) }, "dashboard-settings-devices")),
            },
            {
                path: DashboardSettingsRoutes.device,
                element: (_jsx(Setting, { children: _jsx(DashboardDeviceSettings, {}) }, "dashboard-settings-device")),
            },
        ]),
    },
];
